'use client';
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = Calendar;
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("@aiq/icons/components");
const react_day_picker_1 = require("react-day-picker");
const date_fns_1 = require("date-fns");
const utils_1 = require("../utils");
const navButtonClasses = 'absolute z-10 inline-flex h-8 w-8 items-center justify-center rounded-md border border-neutral-100 bg-surface text-neutral-700 transition-colors hover:border-primary-200 hover:text-neutral-900 disabled:opacity-50';
// Defined here rather than inline in `components={{…}}`: a fresh function on each
// render is a new component type to React, which throws away the nav's DOM and
// state every time the calendar re-renders.
function PreviousMonthButton(_a) {
    var buttonProps = __rest(_a, []);
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({}, buttonProps, { className: (0, utils_1.cn)(navButtonClasses, 'left-0'), type: 'button', children: (0, jsx_runtime_1.jsx)(components_1.AngleLeftIcon, { className: 'h-2.5 w-2.5' }) })));
}
function NextMonthButton(_a) {
    var buttonProps = __rest(_a, []);
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({}, buttonProps, { className: (0, utils_1.cn)(navButtonClasses, 'right-0'), type: 'button', children: (0, jsx_runtime_1.jsx)(components_1.AngleRightIcon, { className: 'h-2.5 w-2.5' }) })));
}
// react-day-picker v9 calendar styled to AIQ:
//   selected day = primary surface, white text
//   range middle = primary-50, primary-800 text
//   today = primary-50 background, primary-700 text (subtle)
//   outside / disabled = neutral-300 muted
//   nav buttons = small icon buttons with neutral-100 border
function Calendar(_a) {
    var { className, classNames: _swallowedClassNames, components, showOutsideDays = true, captionFormat = 'LLLL yyyy', locale, startMonth, endMonth, hidden } = _a, props = __rest(_a, ["className", "classNames", "components", "showOutsideDays", "captionFormat", "locale", "startMonth", "endMonth", "hidden"]);
    return ((0, jsx_runtime_1.jsx)(react_day_picker_1.DayPicker, Object.assign({ className: (0, utils_1.cn)('p-3', className), classNames: {
            months: 'relative',
            month: 'space-y-4',
            month_caption: 'flex justify-center pt-1 relative items-center h-8',
            caption_label: 'text-sm font-semibold capitalize text-neutral-900',
            nav: 'space-x-1 flex items-center absolute h-8 w-full',
            month_grid: 'w-full border-collapse space-y-1',
            weekdays: 'flex',
            weekday: 'text-neutral-500 rounded-md w-9 font-bold text-[11px] uppercase tracking-[0.04em]',
            week: 'flex w-full mt-2',
            day: 'h-9 w-9 text-center text-sm p-0 relative focus-within:relative focus-within:z-20',
            day_button: 'h-9 w-9 p-0 font-medium text-neutral-800 rounded-md transition-colors hover:bg-neutral-50 aria-selected:opacity-100',
            selected: '[&>button]:bg-primary [&>button]:text-white [&>button]:hover:bg-primary-600 [&>button]:focus:bg-primary-600 [&>button]:focus:text-white',
            today: '[&>button]:bg-primary-50 [&>button]:text-primary-700 [&>button]:font-bold',
            outside: '[&>button]:text-neutral-300 [&>button]:hover:bg-transparent',
            disabled: '[&>button]:text-neutral-300 [&>button]:cursor-not-allowed [&>button]:hover:bg-transparent',
            range_start: '[&>button]:bg-primary [&>button]:text-white [&>button]:rounded-r-none',
            range_end: '[&>button]:bg-primary [&>button]:text-white [&>button]:rounded-l-none',
            range_middle: '[&>button]:bg-primary-50 [&>button]:text-primary-800 [&>button]:rounded-none [&>button]:hover:bg-primary-100',
            hidden: 'invisible'
        }, 
        // Consumer components (e.g. a custom DayButton) layer over the styled nav buttons instead of replacing them.
        components: Object.assign({ PreviousMonthButton,
            NextMonthButton }, components), disabled: props.disabled, endMonth: endMonth, formatters: {
            formatCaption: (date) => (0, date_fns_1.format)(date, captionFormat, { locale })
        }, hidden: hidden, locale: locale, mode: 'single', showOutsideDays: showOutsideDays, startMonth: startMonth }, props)));
}
Calendar.displayName = 'Calendar';
